import { VStack } from '@chakra-ui/react'

import Summary, { SummaryProps } from './Summary'

interface Props {
  summaries: SummaryProps[]
  id?: string
}

function SummaryGroup({ summaries, id }: Props): React.ReactElement {
  return (
    <VStack
      id={id}
      spacing="6"
      sx={{
        alignItems: 'stretch',
      }}
    >
      {summaries.map((summary, index) => {
        return <Summary key={`${index}`} {...summary} />
      })}
    </VStack>
  )
}

export default SummaryGroup
